
export default function About() {
  return (
    <div className="bg-[#FAF8F5] py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-24">
          {/* Left Image */}
          <div className="w-2/5">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/a6f1864334d1ff1fd9c87a15910719ac.jpg"
                alt="TUTTO SRL Team"
                className="w-full h-auto rounded-3xl shadow-lg object-cover"
                style={{ height: '500px' }}
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="w-3/5">
            <div className="inline-block mb-6 px-4 py-2 bg-[#E8E3F3] rounded-full">
              <span className="text-xs text-purple-700 font-semibold tracking-widest uppercase">Who We Are</span>
            </div>
            
            <h2 className="text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight">
              Expert Team Building<br />Modern iOS Applications
            </h2>
            
            <p className="text-lg text-[#666666] leading-relaxed mb-12 max-w-xl">
              TUTTO SRL is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices. We combine cutting-edge technology with intuitive design to deliver solutions that users trust and love.
            </p>
            
            <div className="flex items-end gap-4">
              <div className="text-8xl font-serif text-purple-400 leading-none">08+</div>
              <div className="pb-3">
                <p className="text-sm text-[#666666] font-medium">Years of Innovation</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
